import { useState } from 'react';
import { Modal } from './Modal';
import { useSelectedHousehold } from '../hooks/useSelectedHousehold';
import { tapLight } from '../lib/haptics';

/**
 * Header household switcher: a pill showing the current household that opens
 * the same sheet-row picker as the More menu — replacing the raw `<select>`
 * that used to sit in page headers. Renders nothing with fewer than two
 * households (nothing to switch to).
 */
export function HouseholdSwitcher() {
  const { householdId, households, setSelectedId } = useSelectedHousehold();
  const [open, setOpen] = useState(false);

  if (!households || households.length < 2) return null;
  const current = households.find((h) => h.householdId === householdId);

  return (
    <>
      <button
        className="household-switcher"
        onClick={() => { tapLight(); setOpen(true); }}
        aria-label={`Switch household — currently ${current?.name ?? 'none'}`}
      >
        <ion-icon name="home" aria-hidden="true" />
        <span className="household-switcher-name">{current?.name ?? 'Household'}</span>
        <ion-icon name="chevron-down" className="household-switcher-chevron" aria-hidden="true" />
      </button>

      {open && (
        <Modal title="Switch household" onClose={() => setOpen(false)}>
          <div className="sheet-stack">
            {households.map((h) => {
              const selected = h.householdId === householdId;
              return (
                <button
                  key={h.householdId}
                  className={`sheet-row${selected ? ' sheet-row--selected' : ''}`}
                  onClick={() => { tapLight(); setSelectedId(h.householdId); setOpen(false); }}
                >
                  <span className="sheet-row-icon"><ion-icon name="home" /></span>
                  <span className="sheet-row-label">{h.name}</span>
                  {selected && <ion-icon name="checkmark-circle" className="sheet-row-check" />}
                </button>
              );
            })}
          </div>
        </Modal>
      )}
    </>
  );
}
